export const blockIconsTransportationFlightTakeoffNew = (
	<span className='material-symbols-outlined'>flight_takeoff</span>
);
